import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
interface JwtPayload {
  userId: string;
  email: string;
  username: string;
  roles: string;
  firstName: string;
  lastName: string;
  iat: number;
  exp: number;
}
@Injectable({
  providedIn: 'root',
})
export class JwtDecoderService {
  getUserRole(token: string): string {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.roles;
  }
  getUserEmail(token: string): string {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.email;
  }
  getUserId(token: string): string {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.userId;
  }
}
